module.exports = __webpack_public_path__ + "img/exccAuthType1.608c46fc.png";